export default {
  APPOINTMENTS(state, data) {
    state.appointments        = data;
    state.appointmentsLoading = false;
  },

  APPOINTMENTS_APPEARANCE(state, data) {
    state.appointmentsAppearance = data;
  },

  APPOINTMENTS_CANCEL(state, data) {
    state.appointments = state.appointments.filter(
      (appointment) => (appointment.id !== data)
    );
  },

  APPOINTMENTS_HISTORY(state, data) {
    state.appointmentsHistory        = data;
    state.appointmentsHistoryLoading = false;
  },

  APPOINTMENTS_HISTORY_APPEARANCE(state, data) {
    state.appointmentsHistoryAppearance = data;
  }
}
